import React from 'react';

import Benefits from '@/widgets/ServiceLanding/Benefits';

import { FEATURES } from '@/constants/downloadApp';

const Features = () => {
    return (
        <Benefits
            badge='امکانات اپلیکیشن ازکی‌سرویس'
            title='یک اپ؛ تمام خدمات خودرو و موتورسیکلت'
            subtitle='از خدمات در محل تا استعلام و پرداخت آنلاین؛ همه‌چیز را بدون جابه‌جایی بین چند اپ یا سایت مدیریت کنید.'
            items={FEATURES.map((feature) => ({
                icon: feature.icon,
                title: feature.title,
                description: feature.description
            }))}
            sectionClassName='relative bg-N50 py-16 md:py-24'
        />
    );
};

export default Features;
